<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "PorductManage"
    }
</script>

<style scoped>

</style>